import React from 'react';
import { connect } from 'react-redux';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"react-router"' has no exported member 'Co... Remove this comment to see the full error message
import { ContextRouter, withRouter } from 'react-router';

import {
  clearFlashMessages,
  pushFlashMessage,
} from '../redux/main/actions/flashMessages';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/ban-types
type InitialProps = {};
type OwnProps = InitialProps & ContextRouter;
type Props = OwnProps & {
  flashMessages: Array<FlashMessageType>;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pushFlashMessage: (...args: Array<any>) => any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clearFlashMessages: (...args: Array<any>) => any;
};

class SetFlashMessages extends React.PureComponent<Props> {
  componentDidUpdate(prevProps: Props) {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (prevProps.location.pathname !== this.props.location.pathname) {
      // clear flash messages on page navigation
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.clearFlashMessages();
    }

    if (
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      prevProps.location.pathname !== this.props.location.pathname || // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      prevProps.location.state !== this.props.location.state
    ) {
      // load new flash message from router state
      const flashMessage =
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.location.state && this.props.location.state.flashMessage;

      if (flashMessage) {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.pushFlashMessage(flashMessage, true);
      }
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = ({ flashMessages }) => ({
  flashMessages,
});

// @ts-expect-error ts-migrate(2558) FIXME: Expected 2 type arguments, but got 1.
export default withRouter<InitialProps>(
  // @ts-expect-error ts-migrate(2558) FIXME: Expected 5 type arguments, but got 6.
  connect<Props, OwnProps, _, _, _, _>( // $FlowFixMe
    mapStateToProps, // $FlowFixMe
    {
      pushFlashMessage,
      clearFlashMessages,
    }
  )(SetFlashMessages)
);
